import { render, staticRenderFns } from "./EventMarker.vue?vue&type=template&id=af0fa64e&"
import script from "./EventMarker.vue?vue&type=script&lang=js&"
export * from "./EventMarker.vue?vue&type=script&lang=js&"
import style0 from "./EventMarker.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports